import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";
import { Text } from "./Text";
import { Done } from "@mui/icons-material";

import { useState } from "react";

const RenderList = ({ classes, items, keys, def, onSelect }) => {

    const contClass = containerClasses();
    const [selected, setSelected] = useState(def);

    const handleItemChange = (item) => {
        setSelected(item[keys.id]);
        onSelect(item[keys.id]);
    }

    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");
    return (
        <div style={{ width: "100%", overflowY: "scroll", marginBottom: "2em" }}>
            {items.map((item, i) =>
                <div key={i} onClick={() => handleItemChange(item)}
                    className={`${contClass.listItem} ${item[keys.id] === selected ? contClass.selectedItem : ""}`}
                >
                    {item[keys.img] &&
                        <div className={contClass.maxWidth30}>
                            <img src={item[keys.img]} style={{ maxWidth: "2em" }} alt="icon" />
                        </div>
                    }
                    <div className={contClass.width60}>
                        <Text classes={["description", "separateContent"]}>
                            {item[keys.text]}
                            {item[keys.id] === selected && <Done sx={{ margin: "0 1em" }} />}
                        </Text>
                    </div>
                </div>
            )}
        </div>
    );
}

export const List = ({ classes = [], items = [], keys, def = null, onSelect }) => (
    <Fragment>
        <RenderList {...{ classes, items, keys, def, onSelect }} />
    </Fragment>
);